import { Trans } from "react-i18next";

import type { NotificationContentProps } from "../../types";

export default function StageChangedContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.stageChangedFound"
      values={{ challenge: ownerChallenge?.name || "Deleted" }}
    />
  );
}
